// Import the global requirements
import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { checkSessionStatus, checkIfLoggedIn } from "@wantable/Shared"

import { Footer } from '@wantable/Footer'

// declare the id of the element to be used where the component will be rendered
const rootEl = document.getElementById('headless-footer')

const root = createRoot(rootEl)

const FooterWrapper = () => {
  const [loggedIn, setLoggedIn] = useState(false)

  window.addEventListener('token stored', () => {
    setLoggedIn(checkIfLoggedIn())
  })

  useEffect(() => {
    setLoggedIn(checkIfLoggedIn())
  }, [])

  return (
    <Footer
      isLoggedIn={loggedIn}
    />
  )
}

rootEl && root.render(<FooterWrapper />)
